import zh from './zh'
import en from './en'
import ja from './ja'
import ko from './ko'


const messages = {
  zhtw:zh,
  en:en,
  ja:ja,
  ko:ko,
}
export {
  messages
}
